
import Vue from "vue";
import { AllContactsService } from "@/services/all-contacts-service";
import { ContactAddress } from "@/models/base";
import { HumanFilter } from "@/utils/human-filter";
import { UserConfigService} from "@/services";

export default Vue.extend({
	data() {
		return {
			enterPressed: false,
			realTimeText: "",
			foundAddresses: [] as ContactAddress[],
			input: "",
			wait: UserConfigService.getSaleSettings().WaitForEnterOnContactSearch,
		};
	},
	props: {
		value: Object as () => ContactAddress,
		groupId: {
			type: [Number, Array as () => number[]],
		},
		fancy: Boolean,
		label: [String, Object],
		clearOnEnter: Boolean,
		disabled: Boolean,
		icon: String,
		iconLeft: String,
		autoFocus: Boolean,
		iconTooltip: [String, Object],
		iconLeftTooltip: [String, Object],
	},
	computed: {
		computedGroupIds(): number[] {
			if (typeof (this.groupId) == "object") {
				return this.groupId;
			}
			return [this.groupId];
		}
	},
	watch: {
		async input(input: string) {
			this.realTimeText = input;
			if (input.match(/^\s*$/)) {
				this.foundAddresses = [];
				return;
			}
			if(!this.wait) {
				this.foundAddresses = await AllContactsService.searchAddress(this.input, false, this.getGroupExtraFilters());
			}
		},
		value: {
			immediate: true,
			handler() {
				if (this.value) {
					this.input = this.addressToString(this.value);
				} else {
					this.input = "";
				}
			}
		}
	},
	methods: {
		addressToString(address:ContactAddress):string{
			let result = address.getDisplayedName();
			if (!result) {
				if (address.Contact) {
					result = address.Contact.getDisplayName();
				}
			}
			result += " " + address.toAddressString();
			return result;
		},
		onRealTimeValue(text:string){
			this.realTimeText = text;
		},
		keyup(event: KeyboardEvent) {
			if(event.key == "Enter"){
				this.enterPressed = true;
				this.searchOnEnter();
				return;
			}
			if(this.wait && event.key != "ArrowDown" && event.key != "ArrowUp"){
				this.foundAddresses = [];
			}
			//this.$emit("keyup", event);
		},
		async searchOnEnter(){
			let foundAddresses = [] as ContactAddress[];
			this.foundAddresses = [];
			if (this.realTimeText.match(/^\s*$/)) {
				this.foundAddresses = [];
				return;
			}
			if (this.value && this.value.Contact && this.value.Contact.ComputedFriendlyID == this.realTimeText) {
				this.$emit("blur");
				return;
			}
			foundAddresses = await AllContactsService.searchAddress(this.realTimeText, false, this.getGroupExtraFilters());
			if(foundAddresses.length == 1){
				this.selectAddress(foundAddresses[0]);
			}else{
				this.foundAddresses = foundAddresses;
			}
			this.enterPressed = false;
		},
		getGroupExtraFilters():HumanFilter[]{
			if (this.groupId == null) {
				return [];
			}
			if (typeof(this.groupId) == "number"){
				return [
					new HumanFilter({
						Field: "this.Contact.GroupID",
						Operator: "=",
						Values: [`${this.groupId}`]
					}),
				];
			}
			return [
				new HumanFilter({
					Field: "this.Contact.GroupID",
					Operator: "in",
					Values: this.groupId.map(g=>`${g}`)
				})
			];
		},
		onBlur() {
			this.foundAddresses = [];
			if (this.value) {
				this.input = this.addressToString(this.value);
			}else{
				this.input = "";
			}
			this.$emit("blur");
		},
		onFocus() {
			this.input = "";
		},
		selectAddress(address: ContactAddress) {
			this.$emit("input", address);
			if (this.clearOnEnter) {
				this.input = "";
			}
			this.blur();
		},
		focus() {
			(this.$refs.input as any).focus();
		},
		blur() {
			(this.$refs.input as any).blur();
		},
		searchAddresses() {
			if (this.$listeners["icon-click"]){
				return this.$emit("icon-click");
			}
			console.trace("Right icon clicked");
			this.$emit("searchAddresses");
		},
		iconLeftClick(){
			this.$emit("icon-left-click");
		}
	},
	mounted() {
		if (this.autoFocus) {
			this.focus();
		}
	},
	i18nEx: {
		componentPrefix: "components.contact-search"
	}
});
